/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type GetSummary200CardBalancesItemAsset = typeof GetSummary200CardBalancesItemAsset[keyof typeof GetSummary200CardBalancesItemAsset];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSummary200CardBalancesItemAsset = {
  '': '*',
} as const;
